export function emptyIdeaStyleSignature(node) {
  return JSON.stringify([node?.color, node?.fontFamily, node?.fontSize, node?.emoji]);
}

// Only the creating tab tracks a draft. Never infer draft status from an
// empty label, the displayed "New idea" placeholder, or a persisted node.
export function canDiscardEmptyIdea({ node, finalText, rootId, relationships, baseline, currentUserId }) {
  if (!node || !baseline || node.id === rootId || node.isRoot) return false;
  if (String(finalText || '').trim() || String(node.text || '').trim()) return false;
  if (node.userId && node.userId !== currentUserId) return false;
  if (node.lastEditedBy && node.lastEditedBy !== currentUserId) return false;
  if (node.info || node.attachment || node.linkUrl || node.linkMeta || node.isTask
    || node.embeddedMindmapId || node.isEmbeddedMindmapLink || node.responsiblePrincipal
    || node.emoji || node.inbox || node.collapsedChildren || node.tags?.length) return false;
  if (emptyIdeaStyleSignature(node) !== baseline.style) return false;
  return !(relationships || []).some(edge => edge.parentId === node.id);
}
